import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  Nav,
  Row,
  Tab,
  Alert,
} from "react-bootstrap";
import Flatpickr from "react-flatpickr";
import { useSelector } from "react-redux";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDebounce } from "Common/Hooks/UserHooks";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import api from "Common/api";
interface PersonalDataProps {
  data: any;
  userD: any;
  companyD: any;
  licenceImage: any;
  contractorLicenceImage: any;
  insuranceImage: any;
  selectedInput:any;
  profileVideo: any;
  compLogo: any;
  isLoading: any;
  onRemoveImage: (type: string) => void;
  createUserData: (values: any,isNext?:any,inputName?:any) => void;
  createCompanyData: (values: any) => void;
  onFileChange: (type: string, filePath: any) => void;
  handleActivetab: (type: string) => void;
  isPaymentVerified: Boolean;
  companyLicLoading: Boolean;
  insuranceLoading: Boolean;
  contLicLoading: Boolean;
  compLogoLoading: Boolean;
  profileVidLoading: Boolean;
  activeT: string;
  mobilePortfolio?: React.ReactNode;
}
const HomeOwnerPersonal: React.FC<PersonalDataProps> = ({
  data,
  userD,
  createUserData,
  activeT,selectedInput,
  handleActivetab,
  mobilePortfolio,
}) => {
  //console.log(licenceImage, "licenceImagelicenceImage");
  const [userFormattedPhoneNumber, setUserFormattedPhoneNumber] = useState("");
  const [notification, setNotification] = useState<{
    status: boolean;
    message: string;
    variant: "success" | "danger" | "warning" | "info";
  } | null>(null);
  const [zipcodeError,setZipCodeError] = useState("")

  const formatPhoneNumber = (phoneNumber: string) => {
    return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
  };

  const handlePhoneNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const input = event.target.value.replace(/\D/g, ""); // Remove all non-numeric characters
    setUserFormattedPhoneNumber(formatPhoneNumber(input));
    validation.setFieldValue("phoneNumber", input);
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstName: (userD && userD.user_first_name) || "",
      lastName: (userD && userD.user_last_name) || "",
      phoneNumber: (userD && userD.user_phone) || "",
      email: (userD && userD.user_email) || "",
      birthDate: (data != null && data.ua_birth_date) || "",
      cityInput: (data != null && data.ua_city) || "",
      zipcodeInput: (data != null && data.ua_zip_code) || "",
      countryInput: (data != null && data.ua_country) || "United States",
      descpription: (data != null && data.ua_description) || "",
      address: (data != null && data.ua_address) || "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("Please enter your first name"),
      lastName: Yup.string().required("Please enter your last name"),
      phoneNumber: Yup.string().required("Please enter your phone number"),
      email: Yup.string().required("Please enter your email address"),
      cityInput: Yup.string().required("Please enter your city"),
      zipcodeInput: Yup.string().required("Please enter your zip code"),
      descpription: Yup.string().required("Please enter your description"),
      address: Yup.string().required("Please enter your address"),
    }),
    onSubmit: (values) => {
      createUserData(values);
    },
  });

  useEffect(() => {
    if (validation.values.phoneNumber) {
      const userFormattedPhoneNumber = formatPhoneNumber(
        validation.values.phoneNumber
      );
      setUserFormattedPhoneNumber(userFormattedPhoneNumber);
    }
  }, [validation.values.phoneNumber]);

  const handleAlertClick = () => {
    setNotification(null);
  };

  const updatePersonalDetails =(values?:any,inputName?:any)=>{
  createUserData(values?values: validation.values,'ignoreNextPage',inputName)
  }
  const debouncedUpdateUser = useDebounce((values: any,name?:any) => {
     updatePersonalDetails(values,name)
   }, 1000); // 1s debounce
   const getData = (zip: any, ) => {
    axios
      .get(`https://api.zippopotam.us/US/${zip}`, {
      })
      .then((resp: any) => {
        const data = resp;
        if (data && data.places && data.places.length > 0) {
          const place = data.places[0];
          validation.handleChange({
            target: {
              value:  place["place name"]?.replace("City",""),
              name: "cityInput",
              id: "cityInput",
            },
          });
          validation.handleChange({
            target: {
              value:  place["state abbreviation"],
              name: "userState",
              id: "userState",
            },
          });
          validation.handleChange({
            target: {
              value: data["country abbreviation"],
              name: "countryInput",
              id: "countryInput",
            },
          });
          updatePersonalDetails({
            ...validation.values,
            cityInput:  place["place name"]?.replace("City",""),
            userState: place["state abbreviation"],
            zipcodeInput:zip,
            countryInput: data["country abbreviation"],
            
          },"zipcodeInput");
        } else {
          setZipCodeError("Zip Code not found")
     
          setTimeout(() => {
        setZipCodeError("")
          }, 5000);
        
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  return (
    <React.Fragment>
      {notification && notification.status && (
        <div
          style={{
            position: "absolute",
            top: "5%",
            right: "24px",
            zIndex: 99999,
          }}
        >
          <Alert variant={notification.variant} onClick={handleAlertClick}>
            {notification.message}
          </Alert>
        </div>
      )}
      <Col xl={9} className="profile-settings-main tailwind-prefix">
        <Tab.Container
          id="left-tabs-example"
          activeKey={activeT}
          defaultActiveKey={activeT}
        >
          <Row className="profile-settings-section-nav-row d-flex align-items-center flex-wrap gap-2 mb-4">
            <div className="col-md order-1">
              <Nav
                variant="pills"
                className="profile-settings-section-nav arrow-navtabs nav-secondary gap-2 flex-grow-1"
              >
                <Nav.Item>
                  <Nav.Link eventKey="first" href="#personalDetails">
                    Personal Details
                  </Nav.Link>
                </Nav.Item>
                {mobilePortfolio && (
                  <Nav.Item className="profile-settings-mobile-only">
                    <Nav.Link eventKey="sixth" onClick={() => handleActivetab("sixth")}>
                      Portfolio
                    </Nav.Link>
                  </Nav.Item>
                )}
              </Nav>
            </div>
          </Row>
          {mobilePortfolio && (
            <Tab.Content className="profile-settings-mobile-only">
              <Tab.Pane eventKey="sixth" id="mobilePortfolio">
                <Card className="profile-settings-content-card">
                  {mobilePortfolio}
                </Card>
              </Tab.Pane>
            </Tab.Content>
          )}
          <Tab.Content>
            <Tab.Pane eventKey="first" id="personalDetails">
              <Card className="profile-settings-content-card">
                <Card.Header>
                  <h6 className="card-title mb-0">Personal Details</h6>
                </Card.Header>
                <Card.Body>
                  <div className="profile-settings-form-note">
                    <div className="profile-settings-form-note-title">
                      Profile basics
                    </div>
                    <div className="profile-settings-form-note-copy">
                      Keep your contact and location details current so project communication stays accurate.
                    </div>
                  </div>
                  <Form
                    action="#"
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <Row>
                      <Col lg={6}>
                        <div className="mb-3">
                          <Form.Label htmlFor="firstName">
                            First Name
                          </Form.Label>
                          <Form.Control
                            type="text"
                            id="firstName"
                            name="firstName"
                            placeholder="Enter your firstname"
                            required
                    readOnly
                            onBlur={validation.handleBlur}
                            value={validation.values.firstName || ""}
                            isInvalid={
                              validation.touched.firstName &&
                              validation.errors.firstName
                                ? true
                                : false
                            }
                          />
                        </div>
                        {validation.touched.firstName &&
                        validation.errors.firstName ? (
                          <Form.Control.Feedback type="invalid">
                            {/* {validation.errors.firstName} */}
                          </Form.Control.Feedback>
                        ) : null}
                      </Col>

                      <Col lg={6}>
                        <div className="mb-3">
                          <Form.Label htmlFor="lastName">Last Name</Form.Label>
                          <Form.Control
                            type="text"
                    readOnly

                            id="lastName"
                            name="lastName"
                            placeholder="Enter your last name"
                          
                            onBlur={validation.handleBlur}
                            value={validation.values.lastName || ""}
                            isInvalid={
                              validation.touched.lastName &&
                              validation.errors.lastName
                                ? true
                                : false
                            }
                          />
                        </div>
                        {validation.touched.lastName &&
                        validation.errors.lastName ? (
                          <Form.Control.Feedback type="invalid">
                            {typeof validation.errors.lastName === "string"
                              ? validation.errors.lastName
                              : ""}
                          </Form.Control.Feedback>
                        ) : null}
                      </Col>

                      <Col lg={6}>
                        <div className="mb-3">
                          <Form.Label htmlFor="phoneNumber">
                            Phone Number
                          </Form.Label>
                          <Form.Control
                            type="tel"
                            id="phoneNumber"
                            name="phoneNumber"
                    readOnly

                            placeholder="Enter your phone number"
                            required
                            onBlur={validation.handleBlur}
                            value={userFormattedPhoneNumber}
                            isInvalid={
                              validation.touched.phoneNumber &&
                              validation.errors.phoneNumber
                                ? true
                                : false
                            }
                          />
                        </div>
                        {validation.touched.phoneNumber &&
                        validation.errors.phoneNumber ? (
                          <Form.Control.Feedback type="invalid">
                            {typeof validation.errors.phoneNumber === "string"
                              ? validation.errors.phoneNumber
                              : ""}
                          </Form.Control.Feedback>
                        ) : null}
                      </Col>

                      <Col lg={6}>
                        <div className="mb-3">
                          <Form.Label htmlFor="email">Email Address</Form.Label>
                          <Form.Control
                            type="email"
                            id="email"
                            name="email"
                    readOnly

                            placeholder="Enter your email"
                            required
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            isInvalid={
                              validation.touched.email &&
                              validation.errors.email
                                ? true
                                : false
                            }
                          />
                        </div>
                        {validation.touched.email && validation.errors.email ? (
                          <Form.Control.Feedback type="invalid">
                            {typeof validation.errors.email === "string"
                              ? validation.errors.email
                              : ""}
                          </Form.Control.Feedback>
                        ) : null}
                      </Col>

                      <Col lg={6}>
                        <div className="mb-3 position-relative">
                          <Form.Label htmlFor="birthDate">
                            Date of Birth
                          </Form.Label>
                          <Flatpickr
                            id="birthDate"
                            name="birthDate"
                            className="form-control"
                            options={{ dateFormat: "d M, Y" }}
                            placeholder="Select date"
                            value={validation.values.birthDate}
                            onChange={(date:any) => {
                              validation.setFieldValue("birthDate", date[0])

                              debouncedUpdateUser({ ...validation.values, birthDate:date[0] },'birthDate');
                            }}
                          />
                                                   {selectedInput ==="birthDate" && (
   
   <i className="bi bi-check-circle-fill" style={{
position: "absolute",
right: "10px",
top: "47px",
transform: "translateY(-50%)",
color: "green",
fontSize: "1.2rem",
}} />
)}
                          {validation.errors.birthDate &&
                            validation.touched.birthDate && (
                              <Form.Control.Feedback type="invalid">
                                {typeof validation.errors.birthDate === "string"
                                  ? validation.errors.birthDate
                                  : ""}
                              </Form.Control.Feedback>
                            )}
                        </div>
                      </Col>

                      <Col lg={4}>
                        <div className="mb-3">
                          <Form.Label htmlFor="cityInput">City</Form.Label>
                          <Form.Control
                            type="text"
                            id="cityInput"
                            name="cityInput"
                            placeholder="City"
                            readOnly
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.cityInput || ""}
                            isInvalid={
                              validation.touched.cityInput &&
                              validation.errors.cityInput
                                ? true
                                : false
                            }
                          />
                        </div>
                        {validation.touched.cityInput &&
                        validation.errors.cityInput ? (
                          <Form.Control.Feedback type="invalid">
                            {typeof validation.errors.cityInput === "string"
                              ? validation.errors.cityInput
                              : ""}
                          </Form.Control.Feedback>
                        ) : null}
                      </Col>

                      <Col lg={4}>
                        <div className="mb-3">
                          <Form.Label htmlFor="countryInput">
                            Country
                          </Form.Label>
                          <Form.Control
                            type="text"
                            id="countryInput"
                            readOnly
                            name="countryInput"
                            placeholder="Country"
                            required
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={
                              validation.values.countryInput || "United States"
                            }
                            disabled
                            isInvalid={
                              validation.touched.countryInput &&
                              validation.errors.countryInput
                                ? true
                                : false
                            }
                          />
                        </div>
                        {validation.touched.countryInput &&
                        validation.errors.countryInput ? (
                          <Form.Control.Feedback type="invalid">
                            {typeof validation.errors.countryInput === "string"
                              ? validation.errors.countryInput
                              : ""}
                          </Form.Control.Feedback>
                        ) : null}
                      </Col>

                      <Col lg={4}>
                        <div className="mb-3 position-relative">
                          <Form.Label htmlFor="zipcodeInput">
                            Zip Code
                          </Form.Label>
                          <Form.Control
                            type="text"
                            minLength={5}
                            maxLength={6}
                            id="zipcodeInput"
                            name="zipcodeInput"
                            placeholder="Enter zipcode"
                            required
                            onChange={(e) => {
                              validation.handleChange(e);
                              if (e.target.value.length === 5) {
                                getData(e.target.value);
                            

                              }
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.zipcodeInput || ""}
                            isInvalid={
                              validation.touched.zipcodeInput &&
                              validation.errors.zipcodeInput
                                ? true
                                : false
                            }
                          />
                                                                     {selectedInput ==="zipcodeInput" && (
   
   <i className="bi bi-check-circle-fill" style={{
position: "absolute",
right: "10px",
top: "47px",
transform: "translateY(-50%)",
color: "green",
fontSize: "1.2rem",
}} />
)}
                        </div>
                        {zipcodeError && <div className="text-red-500 -mt-4 text-sm mb-2 ">
                          {zipcodeError}  </div>}
                        {validation.touched.zipcodeInput &&
                        validation.errors.zipcodeInput ? (
                          <Form.Control.Feedback type="invalid">
                            {typeof validation.errors.zipcodeInput === "string"
                              ? validation.errors.zipcodeInput
                              : ""}
                          </Form.Control.Feedback>
                        ) : null}
                      </Col>

                      <Col lg={12}>
                        <div className="mb-3 pb-2 position-relative">
                          <Form.Label htmlFor="address">Address</Form.Label>
                          <Form.Control
                            as="textarea"
                            id="address"
                            name="address"
                            placeholder="Enter your address"
                            value={validation.values.address || ""}
                            onChange={(e) => {
                              validation.handleChange(e);
                              debouncedUpdateUser({ ...validation.values, address: e.target.value },e.target.name);
                            }}
                            onBlur={validation.handleBlur}
                            isInvalid={
                              validation.touched.address &&
                              validation.errors.address
                                ? true
                                : false
                            }
                          />
                                               {selectedInput ==="address" && (
   
   <i className="bi bi-check-circle-fill" style={{
position: "absolute",
right: "10px",
top: "47px",
transform: "translateY(-50%)",
color: "green",
fontSize: "1.2rem",
}} />
)}
                          {validation.errors.address &&
                            validation.touched.address && (
                              <Form.Control.Feedback type="invalid">
                                {typeof validation.errors.address === "string"
                                  ? validation.errors.address
                                  : ""}
                              </Form.Control.Feedback>
                            )}
                        </div>
                      </Col>

                      <Col lg={12}>
                        <div className="mb-3 pb-2 position-relative">
                          <Form.Label htmlFor="descpription">
                            Description
                          </Form.Label>
                          <Form.Control
                            as="textarea"
                            id="descpription"
                            name="descpription"
                            placeholder="Enter your description"
                            value={validation.values.descpription || ""}
                            onChange={(e) => {
                              validation.handleChange(e);
                              debouncedUpdateUser({ ...validation.values, descpription: e.target.value },e.target.name);
                            }}
                            onBlur={validation.handleBlur}
                            isInvalid={
                              validation.touched.descpription &&
                              validation.errors.descpription
                                ? true
                                : false
                            }
                          />
                                              {selectedInput ==="descpription" && (
   
   <i className="bi bi-check-circle-fill" style={{
position: "absolute",
right: "10px",
top: "47px",
transform: "translateY(-50%)",
color: "green",
fontSize: "1.2rem",
}} />
)}
                          {validation.errors.descpription &&
                            validation.touched.descpription && (
                              <Form.Control.Feedback type="invalid">
                                {typeof validation.errors.descpription ===
                                "string"
                                  ? validation.errors.descpription
                                  : ""}
                              </Form.Control.Feedback>
                            )}
                        </div>
                      </Col>

                      <Col lg={12}>
                        <div className="hstack gap-2 justify-content-between flex-wrap">
                          <span className="profile-settings-save-hint">
                            Review the details above before saving.
                          </span>
                          <Button type="submit" variant="primary">
                            Save Profile
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </Card.Body>
              </Card>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </Col>
      <ToastContainer />
    </React.Fragment>
  );
};

export default HomeOwnerPersonal;
